export enum ActionType {
  CN5G = 'CN5G',
  GNB = 'gNB',
  OAIBOX = 'OAIBOX',
  FLEX_RIC = 'FLEXRIC',
  USRP = 'USRP',
  LICENSE = 'LICENSE',
}
